import {
  Box,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";

export default function PrizeDraw({ config, onChange }) {
  const updateShow = (value) => {
    onChange({ ...config, show: value });
  };
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Typography variant="subtitle2">Display</Typography>

      <Box display="flex" gap={2} alignItems="flex-end" flexWrap="wrap">
        <FormControl size="small" style={{ minWidth: 80 }}>
          <InputLabel>Show</InputLabel>
          <Select
            value={config.show}
            label="Show"
            onChange={(e) => updateShow(e.target.value)}
          >
            <MenuItem value="2">2</MenuItem>
            <MenuItem value="4">4</MenuItem>
            <MenuItem value="6">6</MenuItem>
          </Select>
        </FormControl>
      </Box>
    </Box>
  );
}
